<template>
  <AudioMatch
    v-for="variant in variants"
    :key="variant"
    :match="props.match"
    :variant="variant"
    :number="number"
    :allow-playback="canPlayMatch"
  />
</template>

<script setup lang="ts">
import { type FragmentType } from '@/shared/graphql/router/fragment-masking'
import AudioMatch, { AudioMatchFragment } from './AudioMatch.vue'
import { computed } from 'vue'

const props = defineProps<{
  match: FragmentType<typeof AudioMatchFragment>
  number: number
  side?: 'registered' | 'infringing'
  allowPlayback?: boolean
}>()

const variants = ['original', 'stem'] as const
const canPlayMatch = computed(() => props.allowPlayback !== false)
</script>
